import React from 'react';

import { TitleBlocLoader, NewsLoader } from '../../components';

import styles from './rubrique-landing-component.module.css';

export const RubriqueLandingLoader: React.FC = React.memo(() => {
    return (
        <React.Fragment>
            <div className={`${styles.root}`}>
                <TitleBlocLoader />
                <div className={`${styles.newsContainer}`}>
                    <div className={`${styles.newsWrapper}`}>
                        <NewsLoader />
                    </div>
                    <div className={`${styles.newsWrapper}`}>
                        <NewsLoader />
                    </div>
                    <div className={`${styles.newsWrapper}`}>
                        <NewsLoader />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});
